/**
 * 消息/告警配置（message）模块英文映射（中文原文 → 英文 扁平映射）
 * 覆盖范围：src/views/message/ 下 表计消息发送记录、告警配置、
 *          消息模板列表及其表单弹窗
 * 术语：消息=Message，告警配置=Alarm Config，模板=Template，
 *       发送=Send，频次=Frequency，签名=Signature
 */
export default {
  'meter_message_record管理页面': 'Meter Message Record Management Page',
  '一天一次': 'Once a day',
  '一月一次': 'Once a month',
  '一周一次': 'Once a week',
  '不启用': 'Disabled',
  '修改操作员Id': 'Updated By Operator Id',
  '修改时间': 'Modified At',
  '关': 'Off',
  '关闭': 'Close',
  '创建人': 'Created By',
  '创建操作员代码': 'Creator Operator Code',
  '创建时间': 'Created At',
  '删除': 'Delete',
  '区域': 'Area',
  '发送信息内容': 'Message Content',
  '发送成功标记 0失败 1成功': 'Send Success Flag (0 Failed 1 Success)',
  '发送方式': 'Send Method',
  '发送方式 1短信 2微信': 'Send Method (1 SMS 2 WeChat)',
  '发送标记 1定时发送 2手动发送': 'Send Flag (1 Scheduled 2 Manual)',
  '发送模板': 'Send Template',
  '发送状态': 'Send Status',
  '发送的微信Id': 'WeChat ID',
  '发送的电话号码': 'Phone Number',
  '发送重试次数': 'Send Retry Count',
  '发送频次': 'Send Frequency',
  '取消选择': 'Deselect',
  '告警类型': 'Alarm Type',
  '告警配置页面': 'Alarm Config Page',
  '告警金额': 'Alarm Amount',
  '备注': 'Remark',
  '导出': 'Export',
  '展开': 'Expand',
  '已选择 {count} 项': '{count} items selected',
  '开': 'On',
  '当前选择': 'Currently selected',
  '所属部门Id': 'Department ID',
  '折叠': 'Collapse',
  '提 交': 'Submit',
  '操作': 'Action',
  '收起': 'Collapse',
  '新增': 'Add',
  '无图片': 'No Image',
  '无文件': 'No File',
  '时间段': 'Time Period',
  '时间输入有误': 'Invalid time input',
  '是否启用': 'Enabled',
  '更多': 'More',
  '未知': 'Unknown',
  '查询': 'Query',
  '模板': 'Template',
  '模板Id': 'Template ID',
  '模板名称': 'Template Name',
  '模板类型': 'Template Type',
  '消息标记：1，剩余金额告警信息': 'Message Flag (1: Remaining Balance Alarm)',
  '消息模板页面': 'Message Template Page',
  '清空': 'Clear',
  '点击选择区域': 'Click to select area',
  '用户主键': 'Customer Key',
  '用户名称': 'Customer Name',
  '用户地址': 'Customer Address',
  '用户姓名': 'Customer Name',
  '用户编号': 'Customer No.',
  '确定删除吗?': 'Are you sure you want to delete?',
  '签名': 'Signature',
  '编辑': 'Edit',
  '表编号': 'Meter No.',
  '规则名称': 'Rule Name',
  '详情': 'Details',
  '请规则名称': 'Please enter rule name',
  '请输入修改操作员Id': 'Please enter updater ID',
  '请输入创建操作员代码': 'Please enter creator operator code',
  '请输入创建时间!': 'Please enter the creation time!',
  '请输入区域名称': 'Please enter area name',
  '请输入发送信息内容': 'Please enter message content',
  '请输入发送成功标记 0失败 1成功': 'Please enter send success flag',
  '请输入发送方式 1短信 2微信': 'Please enter send method',
  '请输入发送标记 1定时发送 2手动发送': 'Please enter send flag',
  '请输入发送的微信Id': 'Please enter WeChat ID',
  '请输入发送的电话号码': 'Please enter phone number',
  '请输入发送重试次数': 'Please enter send retry count',
  '请输入告警金额': 'Please enter alarm amount',
  '请输入备注': 'Please enter remark',
  '请输入所属部门Id': 'Please enter department ID',
  '请输入模板id': 'Please enter template ID',
  '请输入模板名称': 'Please enter template name',
  '请输入消息标记：1，剩余金额告警信息': 'Please enter message flag',
  '请输入appId': 'Please enter appId',
  '请输入appSecret': 'Please enter appSecret',
  '请输入appKey': 'Please enter appKey',
  '请输入remark': 'Please enter remark',
  '请输入用户主键': 'Please enter customer key',
  '请输入用户名称进行查询': 'Enter customer name to search',
  '请输入用户编号': 'Please enter customer No.',
  '请输入用户编号进行查询': 'Enter customer No. to search',
  '请输入签名': 'Please enter signature',
  '请输入结束时间': 'Please enter end time',
  '请输入表编号': 'Please enter meter No.',
  '请输入表编号进行查询': 'Enter meter No. to search',
  '请输入规则名称': 'Please enter rule name',
  '请输入起始时间': 'Please enter start time',
  '请输名称进行查询': 'Enter a name to search',
  '请选择修改时间': 'Please select modified time',
  '请选择创建时间': 'Please select creation time',
  '请选择发送方式': 'Please select send method',
  '请选择发送频次': 'Please select send frequency',
  '请选择告警类型': 'Select alarm type',
  '请选择成功标志': 'Please select success flag',
  '请选择模板': 'Please select template',
  '请选择模板类型': 'Please select template type',
  '请选择消息发送配置': 'Please select message send config',
  '选择': 'Select',
  '重置': 'Reset',
  '余额不足告警': 'Insufficient Balance Alarm',
  '剩余金额告警': 'Remaining Balance Alarm',
  '失败': 'Failed',
  '成功': 'Success',
  '未绑定': 'Unbound',
  '短信': 'SMS',
  '短信模板': 'SMS Template',
  '微信消息': 'WeChat Message',
  '微信模板': 'WeChat Template',
}
